
import ReactHTMLTableToExcel from "react-html-table-to-excel"

export const GardenMasterExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '45%' }}>

                <h5><span>&emsp;</span></h5>
                <tr>
                    <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>
                {/* <tr><td></td></tr> */}

                <thead className="thead-dark m-0 p-0" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff"}}>

                        <th style={{ borderLeft: "1px solid black" }}>Sr.No.</th>
                        <th style={{ borderLeft: "1px solid white" }}>Ward Name</th>
                        <th style={{ borderLeft: "1px solid white",width:'6em' }}>Sector Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Area Name</th>
                        {
                            searchName === 'Garden Master' ?
                                <th style={{ borderLeft: "1px solid white" }}>Garden Name</th>
                                : (searchName === 'Road Divider') ?
                                    <th style={{ borderLeft: "1px solid white" }}>Road Divider Name</th>
                                    : (searchName === 'Open Space') ?
                                        <th style={{ borderLeft: "1px solid white" }}>Open Space</th>
                                        : (searchName === 'Tree Belt’s') ?
                                            <th style={{ width: '25%', borderLeft: "1px solid white" }}>Tree Belt's Name</th>
                                            : <th style={{ borderLeft: "1px solid white" }}>chowks Name</th>
                        }
                        <th style={{ borderLeft: "1px solid white" }}>Area (in sq meter)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center", border: '1px solid black' }}>
                                <td >{item.rowNum}</td>
                                <td>{item.wardName ? item.wardName : '-'}</td>
                                <td>{item.sectorName ? item.sectorName : '-'}</td>
                                <td>{item.areaName ? item.areaName : '-'}</td>
                                {
                                    searchName === 'Garden Master' ?
                                        <td>{item.assetName ? item.assetName : '-'}</td>
                                        : (searchName === 'Road Divider') ?
                                            <td>{item.assetName ? item.assetName : '-'}</td>
                                            : (searchName === 'Open Space') ?
                                                <td>{item.assetName ? item.assetName : '-'}</td>
                                                : (searchName === 'Tree Belt’s') ?
                                                    <td>{item.assetName ? item.assetName : '-'}</td>
                                                    : <td>{item.assetName ? item.assetName : '-'}</td>

                                }
                                <td>{item.areaInSquareMetre ? item.areaInSquareMetre : '-'}</td>
                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}